import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { trackAddToCart } from '../utils/metaPixel';
export function OfferBlock() {
  const handleBuyClick = () => {
    trackAddToCart();
  };
  return <section id="oferta" className="bg-navy-dark py-24 md:py-32 text-white relative overflow-hidden" data-id="element-108">
      {/* Background accents */}
      <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-navy-dark via-gold-accent to-navy-dark" data-id="element-109"></div>
      <div className="absolute -bottom-40 -right-40 w-96 h-96 bg-gold-accent opacity-20 rounded-full blur-3xl" data-id="element-110"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-111">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-navy-light p-8 md:p-16 rounded-3xl shadow-2xl border border-gold-accent/30" data-id="element-112">
          <h2 className="text-4xl md:text-5xl font-bold uppercase mb-6 leading-tight" data-id="element-113">
            Deja de pagarle a un intermediario para que te devuelva{' '}
            <span className="text-gold-accent" data-id="element-114">tu propio dinero</span>.
          </h2>
          <p className="text-xl text-gray-300 font-body mb-10" data-id="element-115">
            Obtén la Guía de Libertad Fiscal hoy mismo.
          </p>

          <div className="mb-10 flex flex-col items-center" data-id="element-116">
            <p className="text-sm text-gray-400 uppercase tracking-widest mb-3 font-bold" data-id="element-117">
              Un preparador profesional te cobra
            </p>
            <div className="flex items-center gap-4" data-id="element-118">
              <span className="text-3xl font-bold text-gray-500 line-through font-heading" data-id="element-119">
                $200
              </span>
              <span className="text-2xl text-gray-400 font-body" data-id="element-120">→</span>
              <span className="text-7xl md:text-8xl font-extrabold text-white font-heading tracking-tighter" data-id="element-121">
                $4.99
              </span>
            </div>
            <span className="mt-3 inline-block bg-gold-accent/20 text-gold-accent text-sm font-bold px-4 py-1.5 rounded-full uppercase tracking-wide" data-id="element-122">
              Ahorra más de $195
            </span>
          </div>

          <CTAButton href="https://ayudadigiguia.com/cart/47417059344614:1" onClick={handleBuyClick} className="w-full md:w-auto text-xl py-5 px-10" data-id="element-123">
            OBTEN TU GUIA AHORA
          </CTAButton>

          <p className="mt-6 text-gray-400 font-body text-sm" data-id="element-124">
            Descarga instantánea y declara por $0 hoy mismo.
          </p>
        </motion.div>
      </div>
    </section>;
}